import { render, staticRenderFns } from "./uploadButton.vue?vue&type=template&id=ae6f3646&"
import script from "./uploadButton.vue?vue&type=script&lang=js&"
export * from "./uploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports